import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse, HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {catchError, finalize, map} from 'rxjs/operators';
import {constants} from '../constant/constant';


@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  user: any;
  userid: any;


  constructor(private router: Router,) {
    this.userid =0;
    if(localStorage.getItem('userDetail') || localStorage.getItem('userDetail')!=null || localStorage.getItem('userDetail')!=undefined){
      this.userid=JSON.parse(localStorage.getItem('userDetail')).id
    }else {

    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url == constants.main_url +'/user/login') {
      return next.handle(req).pipe(
        catchError(err => {
          if (err instanceof HttpErrorResponse) {

            if (err.status === 401 || err.status === 403) {
              // Invalidate user session and redirect to login/home
              // Swal.fire({
              //   position: 'bottom-end',
              //   type: 'error',
              //   title: 'User name or password incorrect',
              //   showConfirmButton: false,
              //   timer: 2000
              // })
            }

            // return the error back to the caller
            return throwError(err);
          }
        }),
        finalize(() => {
          // any cleanup or final activities
        })
      );
    }else if(req.url == constants.main_url +'/gallery/upload'){
      req = req.clone({
        setHeaders: {
          'USER':'mewan',
          'BIZ':'TRAVEL',
        },

      })
      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('event--->>>', event);
            switch (event.status) {
              case 401 :
                return this.handleError(req, next);
            }
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          let data = {};
          data = {
            reason: error && error.error && error.error.reason ? error.error.reason : '',
            status: error.status
          };
          switch (error.status) {
            case 401 :
              return this.handleError(req, next);
            case 500:
              return this.displayAlert(req, next);
            case 403:
              return this.forbiddenError(req, next);
            case 404:
              return this.notFoundError(req, next);
            case 0:
              return this.connectionError(req, next);
            default:
              return throwError(error);
          }
          return throwError(error);
        }));
    }
    else {
      req = req.clone({
        setHeaders: {
          // 'Content-Type': 'application/json; charset=utf-8;',
          // 'Accept': 'application/json',
          'USER':'mewan',
          'BIZ':'TRAVEL',
        },
      })
      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('event--->>>', event);
            switch (event.status) {
              case 401 :
                return this.handleError(req, next);
            }
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          let data = {};
          data = {
            reason: error && error.error && error.error.reason ? error.error.reason : '',
            status: error.status
          };
          switch (error.status) {
            case 401 :
              return this.handleError(req, next);
            case 500:
              return this.displayAlert(req, next);
            case 403:
              return this.forbiddenError(req, next);
            case 404:
              return this.notFoundError(req, next);
            case 0:
              return this.connectionError(req, next);
            default:
              return throwError(error);
          }
          return throwError(error);
        }));
      ;
    }
  }


  connectionError(req: HttpRequest<any>, next: HttpHandler): any {
    // this.notifier.notify('danger', 'No internet connection !');
  }

  notFoundError(req: HttpRequest<any>, next: HttpHandler): any {
    this.router.navigate(['/error-404']);
  }

  forbiddenError(req: HttpRequest<any>, next: HttpHandler): any {
    // this.notifier.notify('danger', 'The page or resources you were trying to reach is absolutely forbidden because your account is inactive.');

    this.router.navigate(['/login']);
    localStorage.clear();

    return next.handle(req);
  }

  displayAlert(req: HttpRequest<any>, next: HttpHandler): any {
    // this.notifier.notify('danger', 'Something went wrong. please try again later.');

    return next.handle(req);
  }

  handleError(req: HttpRequest<any>, next: HttpHandler): any {
    this.router.navigate(['login']);
    localStorage.clear();
  }
}
